import { useMemo } from 'react';
import { useAppSelector } from '../store/hooks';
import type { RootState } from '../store/types';
import { getLocalizationManager } from './utils';

export const useLocalization = () => {
    const locale = useAppSelector((state: RootState) => state.user.locale);

    return useMemo(() => getLocalizationManager(locale), [locale]);
};

export default useLocalization;
